import React, { useEffect, useState } from 'react';
import { host_url } from '../../App'; // Import host_url
import './wahlkreis.css';
import '../ListenSubpage.css';
import '../../styles/CiTable.css';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';

function Wahlkreis() {
  const [columns, setColumns] = useState({
    Zeltname: true,
    Kindname: true,
    Wahlkreis: true,
    Gewählt: true,
  });
  const [daten, setDaten] = useState([]);
  const [anzahlWahlkreise, setAnzahlWahlkreise] = useState(1);

  useEffect(() => {
    fetch(`${host_url}/kinder`)
      .then(response => response.json())
      .then(data => {
        const groupedData = groupByTent(data);
        setDaten(assignDistricts(groupedData, anzahlWahlkreise));
      })
      .catch(error => console.error('Error fetching kinder:', error));
  }, [anzahlWahlkreise]);

  const handleColumnChange = (column) => {
    setColumns(prevColumns => ({
      ...prevColumns,
      [column]: !prevColumns[column]
    }));
  };

  const handleAnzahlWahlkreiseChange = (event) => {
    setAnzahlWahlkreise(Number(event.target.value));
  };

  const groupByTent = (data) => {
    return data.reduce((acc, curr) => {
      if (!acc[curr.Zeltname]) {
        acc[curr.Zeltname] = [];
      }
      acc[curr.Zeltname].push(curr);
      return acc;
    }, {});
  };

  const assignDistricts = (groupedData, numDistricts) => {
    const tents = Object.keys(groupedData);
    const districts = Array.from({ length: numDistricts }, () => []);
    let districtIndex = 0;

    tents.forEach(tent => {
      groupedData[tent].forEach(child => {
        child.Wahlkreis = districtIndex + 1;
      });
      districts[districtIndex].push(...groupedData[tent]);
      districtIndex = (districtIndex + 1) % numDistricts;
    });

    return districts.flat();
  };

  return (
    <KernteamLayout>
    <div className="container">
      <BackArrow to="/listen" />
      <h1 className="section-title blue no-print">Zuteilung von Wahlkreisen</h1>
      <main>
        <form className="no-print">
          <div className="checkbox-container">
            <h4>Wähle aus, welche Spalten angezeigt werden sollen</h4>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Zeltname} onChange={() => handleColumnChange('Zeltname')} />
              Zeltname
            </label>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Kindname} onChange={() => handleColumnChange('Kindname')} />
              Kindname
            </label>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Gewählt} onChange={() => handleColumnChange('Gewählt')} />
              Gewählt
            </label>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Wahlkreis} onChange={() => handleColumnChange('Wahlkreis')} />
              Wahlkreis
            </label>
          </div>
          <div className="input-container">
            <label>
              Anzahl Wahlkreise
              <input type="number" value={anzahlWahlkreise} onChange={handleAnzahlWahlkreiseChange} min="1" />
            </label>
          </div>
        </form>
        {daten.length > 0 ? (
          daten.reduce((acc, row, index) => {
            if (index === 0 || daten[index - 1].Wahlkreis !== row.Wahlkreis) {
              acc.push(
                <div key={`district-${row.Wahlkreis}`} className="new-page">
                  <div className="table-header">
                    <h2>Wahlkreis {row.Wahlkreis}</h2>
                    <span className="print-link no-print" onClick={() => window.print()}>
                      <span className="material-symbols-outlined">print</span>
                      <span className="print-text">Drucken</span>
                    </span>
                  </div>
                  <div className="ci-table-wrapper">
                  <table className="ci-table">
                    <thead>
                      <tr>
                        {columns.Zeltname && <th>Zeltname</th>}
                        {columns.Kindname && <th>Kindname</th>}
                        {columns.Wahlkreis && <th>Wahlkreis</th>}
                        {columns.Gewählt && <th>Gewählt</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {daten.filter(child => child.Wahlkreis === row.Wahlkreis).map((child, childIndex) => (
                        <tr key={childIndex} className="tent-row">
                          {columns.Zeltname && <td>{child.Zeltname}</td>}
                          {columns.Kindname && <td>{child.Name}</td>}
                          {columns.Wahlkreis && <td>{child.Wahlkreis}</td>}
                          {columns.Gewählt && <td></td>}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </div>
              );
            }
            return acc;
          }, [])
        ) : (
          <p>Keine Daten gefunden.</p>
        )}
      </main>
    </div>
    </KernteamLayout>
  );
}

export default Wahlkreis;